import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Secure.module.scss';

export const SecureStepTwo = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.secureLeftSection}>
        <span className={styles.secureStepLeft_1}>Secure Data with</span>
        <span className={styles.secureStepLeft_2}>FCE</span>
        <span className={styles.secureStepLeft_3}>Blockchain</span>
        <span className={styles.secureStepLeft_4}>and</span>
        <span className={styles.secureStepLeft_5}>Tokenization</span>
      </div>
    }
    rightContent={
      <div className={styles.secureStepContentWrapper}>
        <p>
          The TransparenTerra blockchain is a tool for: <br />
          - verification of user data;
          <br />
          - notarization of documents and certificates;
          <br />
          - tokenization of companies and assets; (currently available for Swiss companies only)
          <br />
          - creating an NFT/NFA on the TransparenTerra Marketplace.
          <br />
        </p>
      </div>
    }
  />
);
